import React from "react";
import { Form, Input } from "antd";
import { requiredFieldRule } from "../../../components/RequiredFieldRule";
import "../../layout/Style.css";
import { ElementIDS } from "../../../components/common/ElementsIDs";
import { useSelector } from "react-redux";
const AddDepartmentForm = (props) => {
  const { englishLang } = useSelector((store) => ({
    englishLang: store.langReducer.englishLang,
  }));
  return (
    <Form
      labelCol={{ xs: 24, sm: 24, md: 6, lg: 8, xl: 6 }}
      wrapperCol={{ xs: 24, sm: 24, md: 14, lg: 14, xl: 14 }}
      form={props.form}
      name="department-form"
      onFinish={props.handleSave}
    >
      <Form.Item
        id={ElementIDS().name}
        label={props.language?.NAME?.value ?? englishLang?.NAME?.value}
        name="name"
        rules={requiredFieldRule}
      >
        <Input
          onChange={(e) => {
            props.setDirty();
          }}
          disabled={
            props.readOnly && props.readOnly.viewOption ? "disabled" : null
          }
        />
      </Form.Item>
      {props.footer}
    </Form>
  );
};

export default AddDepartmentForm;
